<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to project menu" @click="$router.push(`/projects/detail`)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="projects" pageId="creating-task" color="white"></help-link>
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y :disabled="isAdminProject"> 
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(project.status)"  dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;{{ commonfn.getStatusDescription(project.status) }}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="isCompleted" :key="0" @click="updateStatus(commonfn.getStatusCode('In Progress'))" title="Set status to In Progress">
                                <v-list-tile-title small>In Progress</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="isInProgress" :key="0" @click="updateStatus(commonfn.getStatusCode('Completed'))" title="Set status to Completed">
                                <v-list-tile-title small>Completed</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <!-- details -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;margin-bottom:10px;">
                <v-toolbar flat height="35px" class="font-weight-bold">
                    <span>Project Details</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="hasEditRights&&!isAdminProject&&hasNoProjectCharges" icon small @click="showDelete" title="Delete Project">
                        <v-icon small>delete</v-icon>
                    </v-btn>
                    <v-btn v-if="hasEditRights&&!isAdminProject" icon small @click="showEdit" title="Edit Project Details">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout row wrap>
                     <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Project Id :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{project.projectKey}}
                            </v-flex>  
                        </v-layout>   
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Project Code: 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{project.projectCode}}
                            </v-flex>  
                        </v-layout>    
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Project Name :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{project.projectName}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Client :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{project.client}}
                            </v-flex>  
                        </v-layout>
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Project Duration: 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="isAdminProject">No project duration</span>
                                <span v-else>{{project.startDate | moment('MMM DD, YYYY')}} to {{project.endDate | moment('MMM DD, YYYY')}}</span>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Total Charges :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{numFormat.formatNumber(projectTotalCharges)}} hours
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Project Description: 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{project.projectDescription}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- project tasks  -->
            <v-card class="elavation-1" style="margin:10px 0 0px 0">
                <v-toolbar flat height="45px" class="font-weight-bold">
                    <v-text-field v-model="search" append-icon="search" label="Search task code, name, description" single-line hide-details style="margin-bottom:15px;font-weight:400;"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn v-if="hasEditRights&&!isAdminProject" small dark color="primary" title="Add Project Task" @click="addProjectTask">
                    <v-icon dark>add</v-icon>&nbsp;Create Task&nbsp;&nbsp;
                </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="project_tasks_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" :style="isAdminProject?'':'cursor:pointer'" :title="isAdminProject?'':'Click to view project task details'">
                            <td>{{props.item.projectTaskKey}}</td>
                            <td>{{props.item.taskCode}}</td>
                            <td>{{props.item.taskName}}</td>
                            <td>{{props.item.taskDescription}}</td>
                            <td>
                                <div class="text-xs-right">
                                    {{numFormat.formatNumber(props.item.totalCharges)}}
                                </div>
                            </td>
                            <td>
                                <span v-if="props.item.billable">Yes</span>
                                <span v-else>No</span>
                            </td>
                            <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedProjectId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
    
        <v-dialog v-model="dialogProjectTask" width="500" persistent>   
            <project-task ref="projectTaskCompRef" @send="updateHandler" :dialogProjectTask.sync="dialogProjectTask"></project-task>
        </v-dialog>
        <v-dialog v-model="dialogProject" width="600" persistent>   
            <project ref="projectCompRef" @send="getProjectDetails(false)" :dialogProject.sync="dialogProject"></project>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteProject"></delete>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedProjectId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import projectsApi from '@/api/projects'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import numFormat from '@/common/num_format'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {   
    name: 'Projects',
    metaInfo: {
        title: 'Projects',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Create Project' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },  
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'project': () => import('@/components/Projects/AddEditProject'),
        'project-task': () => import('@/components/Projects/AddEditProjectTask'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {      
            numFormat, 
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,    
            loading_download: false,
            loading_delete: false,
            loading_status: false,
            search: null,
            dialogProjectTask: false,
            dialogProject: false,
            dialogDelete: false,
            headers: [
                {text: 'Project Task Id', align: 'left', value: 'projectTaskKey', width: '5%', sortable:true},
                {text: 'Task Code', align: 'left', value: 'taskCode', width: '5%', sortable:true},
                {text: 'Task Name', align: 'left', value: 'taskName', width: '25%', sortable:true},
                {text: 'Description', align: 'left', value: 'taskDescription', width: '25%', sortable:true},
                {text: 'Total Charges (hours)', align: 'right', value: 'totalCharges', width: '20%', sortable:true}, 
                {text: 'Billable', align: 'left', value: 'billable', width: '10%', sortable:true}, 
                {text: 'Created On', align: 'left', value: 'createdOn', width: '15%', sortable:true},
            ],
            expand: false,
            project: null,
            project_tasks: [],
            menu_status: false,
        }
    },
    methods: { 
        showDelete() {
            this.$refs.refDeleteComponent.setMessage("Delete this Project?")
            this.dialogDelete = true
        },
        async updateStatus(status) {
            try{
                this.loading_status = true
                this.project.status = status
                const response = await projectsApi.updateProject(this.project)
                if (response && response.status == 200) {                    
                    this.getProjectDetails(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async deleteProject() {
            try{
                this.loading_delete = true
                const data = {
                    projectid: this.selectedProjectId
                }
                const response = await projectsApi.deleteProject(data)
                if (response && response.status == 200) {                    
                    this.$router.push('/projects/detail')
                }
                this.loading_delete = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEdit() {
            this.$refs.projectCompRef.setData(this.project)
            this.dialogProject = true
        },
        viewDetails(data) {
            if (!this.isAdminProject) {
                this.$router.push(`${data.projectId}/${data.projectTaskId}`)
            }
        },
        addProjectTask() {
            this.$refs.projectTaskCompRef.setProjectTaskAdd(this.selectedProjectId)
            this.dialogProjectTask = true
        },
        async getProjectDetails(show_loading) {
            try{
                this.loading = show_loading
                const response = await projectsApi.getById(this.selectedProjectId)
                if (response && response.status == 200) {                    
                    this.project = response.data
                    this.project_tasks = response.data.projectTasks
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler() {
            this.getProjectDetails(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Project Details'
        })

        this.getProjectDetails(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        selectedProjectId() {
            return this.$route.params.id
        },
        projectTotalCharges() {
            if (this.project_tasks.length) {
                return this.project_tasks.map(x=>x.totalCharges).reduce((prev,next)=>prev+next)
            }
            return 0
        },
        hasNoProjectCharges() {
            return this.projectTotalCharges == 0
        },
        isAdminProject() {
            if (this.project) {
                return this.project.isAdminProject
            }
        },
        isInProgress() {
            if (this.project) {
                return this.project.status == commonfn.getStatusCode('In Progress')
            }
        },
        isCompleted() {
            if (this.project) {
                return this.project.status == commonfn.getStatusCode('Completed')
            }
        },
        commentsData() {
            if (this.project) {
                return {
                    pageQueryId: this.selectedProjectId,
                    pageItemCreatedBy: this.project.createdBy,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.projects,
                    notificationTypeId: notificationTypes.project_details
                }
            }
        },
        project_tasks_filtered() {
            if (this.search) {
                var temp = this.project_tasks.filter(t => {
                    return t.taskName.toLowerCase().includes(this.search.toLowerCase())
                        || t.taskDescription.toLowerCase().includes(this.search.toLowerCase())
                        || t.taskCode.toLowerCase().includes(this.search.toLowerCase())
                        || t.projectTaskKey.toLowerCase().includes(this.search.toLowerCase())
                }) 
                return temp
            }
            return this.project_tasks
        }
    } 
  }
</script>